export const maxPlayersNumber = 6;